import React, { useEffect, useRef, useState } from 'react'
import exportImg from "../../assets/Group 923.svg"
import "./ExportBox.css"
import { useLocation, useNavigate } from 'react-router-dom';
import CustomBtn from '../CustomBtn/CustomBtn';
import { Modal } from 'react-bootstrap';
// import { Alert } from 'react-bootstrap';

import CustomInput from '../CustomInput/CustomInput';
// import axios from 'axios';
import { useSelector } from 'react-redux';
import "react-toastify/dist/ReactToastify.css";
import { toast, ToastContainer } from 'react-toastify';
import Select from 'react-select';

function ExportBox({ title, paragrapg, addingBtn, exportState,onDataChanged }) {
  const { currentLocal } = useSelector((state) => state.currentLocal);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const navigate = useNavigate();
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const location = useLocation();
  const pathParts = location.pathname.split("/"); // Split path into parts
  const path = pathParts[pathParts.length - 1]; // Get last part
  const [show, setShow] = useState(false);
  const [name, setName] = useState('');
  const [stageLoading, setStageLoading] = useState('')
  const [grade_id, setSelectedGradeId] = useState(""); // State to store selected ID
  const userinfo = useSelector((state) => state);
  const [gradeItems, setGradeItems] = useState([])
  const [items, setItems] = useState([""]); // Stores single text in an array
  const fileInputRef = useRef(null);




  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  // const addStage = async (e) => {
  //   e.preventDefault();
  //   setStageLoading(true);
  //   if (path === "grades") {

  //     try {
  //       const response = await axios.post('https://taarteb.com/api/grades', {
  //         "grades": [
  //           {
  //             "name": items[0],
  //             "is_final": 0
  //           }
  //         ],
  //         "grade_category_id": grade_id.value
  //       }, {
  //         headers: {
  //           Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
  //         }
  //       });

  //       // toast.success(response.data.message, { position: "bottom-right", autoClose: 3000 });
  //       setShow(false)
  //       setName('')
  //       setSelectedGradeId('')
  //       if (onDataChanged) {
  //         onDataChanged(); 
  //       }   
  //        } catch (error) {
  //       console.error("Error:", error.response?.data || error.message);
  //       toast.error(Object.values(error.response.data.errors)[0][0], { position: "bottom-right", autoClose: 3000 });

  //     } finally {
  //       setStageLoading(false);
  //     }
  //   } else {
  //     try {
  //       const response = await axios.post('https://taarteb.com/api/grade-categories', {
  //         names: items
  //       }, {
  //         headers: {
  //           Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
  //         }
  //       });
  //       setName("")
  //       setShow(false)
  //       if (onDataChanged) {
  //         onDataChanged(); 
  //       }   
  //     } catch (error) {
  //       console.error("Error:", error.response?.data || error.message);

  //     } finally {
  //       setStageLoading(false);
  //     }
  //   }


  // }

  // const handleExportClick = () => {
  //   fileInputRef.current.click(); // Programmatically trigger file input
  // };

  const exportSheet = async (e) => {
    e.preventDefault();

    if (!e.target.files[0]) {
      toast.error('please upload Weekly Timetable', { position: "bottom-right", autoClose: 3000 });

    } else {    
      const formData = new FormData();
      formData.append("file", e.target.files[0]);
      // try {
      //   const response = await axios.post(`https://taarteb.com/api/${pathParts[2]==="time-table"?"sessions":path.toLowerCase()}/import`, formData, {
      //     headers: {
      //       "Content-Type": "multipart/form-data",
      //       Authorization: `Bearer ${userinfo.auth.userArray.access_token}`

      //     },
      //   });
      //   toast.success(response.data.message, { position: "bottom-right", autoClose: 3000 });
      // } catch (error) {
      //   toast.error(Object.values(error.response.data.errors.errors)[0][0], { position: "bottom-right", autoClose: 3000 });

      // }
    }

  };
  return (
    <>
      <ToastContainer />

      <div className="export_container">
        <div>
          <p className="mb-2 title">{title}</p>
          <p className="mb-2 paragrapg">{paragrapg}</p>

        </div>
        <div className="d-flex align-items-center">
          {exportState ?
            <>
              <div className="export_btn mx-2" onClick={()=>{}}>
                <img src={exportImg} alt="" />
                <span className="mx-1">{currentLocal.home.export}</span>
              </div>

              <input
                type="file"
                accept=".xlsx, .xls"
                ref={fileInputRef}
                onChange={exportSheet}
                style={{ display: "none" }}
              />
            </>
            :
            <div className='export_btn border-0'>
            </div>

          }
          {
            pathParts[2] === "structure" ? (
              <CustomBtn text={addingBtn} clickingFunction={handleShow} />
            ) : addingBtn ? (
              <CustomBtn
                text={addingBtn}
                clickingFunction={() => navigate(`${location.pathname.toLowerCase()}/add`)}
              />
            ) : null
          }      </div>
        <Modal show={show} onHide={handleClose} centered className='modal_container'>
          <Modal.Header >
            <Modal.Title className='modal_title'>{path === "stages" ? currentLocal.home.addStage : currentLocal.home.addGrade}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form>
              {path === 'grades' &&
                <div>
                  <label>
                    {currentLocal.home.stageName}
                  </label>

                  <div className='mb-3'>
                    <Select
                      value={grade_id}
                      onChange={(selectedOption) => setSelectedGradeId(selectedOption)}
                      options={gradeItems}
                      placeholder={currentLocal.home.SelectStage}

                    />
                  </div>
                </div>
              }
              <div>


                <label className="text-mutedx">{path === "stages" ? currentLocal.home.stageName : currentLocal.home.gradeName}</label>
                <CustomInput
                  placeholder={`${path === "stages" ? currentLocal.home.stageName : currentLocal.home.gradeName} `}
                  value={name}
                  onChange={(e) => {
                    setItems([e.target.value]); // Replace the entire array with the new text
                    setName(e.target.value)


                  }}
                />
              </div>

            </form>
          </Modal.Body>
          <Modal.Footer className='d-flex justify-content-center border-top-0 pt-0'>


            <CustomBtn text={stageLoading ? currentLocal.home.Loading : currentLocal.home.add} disabled={stageLoading} clickingFunction={()=>{}} />

          </Modal.Footer>
        </Modal>
      </div>
    </>
  )
}

export default ExportBox
